export default __webpack_public_path__ + "static/secondary_3-a8b9f64273c00dedfc759a7198e93d54.png";